export default __webpack_public_path__ + "static/media/updated-ISEO.4a07f3fe.pdf";